var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/EditorTextItalic.tsx"; // This file was auto-generated using scripts/generate-icons.js
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from editor-text-italic.svg
 */
export default function EditorTextItalicIcon(props) {
  return _jsxDEV("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    "data-component": "EditorTextItalicIcon",
    ...props,
    children: _jsxDEV("g", {
      "fill-rule": "evenodd",
      children: [_jsxDEV("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        fill: "currentColor",
        d: "M10.61 16q.18 0 .329-.14a.63.63 0 0 0 .191-.317l.457-2.176a.35.35 0 0 0-.063-.313.34.34 0 0 0-.277-.133H8.845q-.213-.012-.17-.235l1.892-9.372q.053-.223.266-.223H13a.5.5 0 0 0 .335-.14.6.6 0 0 0 .196-.318L13.99.457a.5.5 0 0 0 .011-.1.34.34 0 0 0-.085-.223.34.34 0 0 0-.276-.134H5.805a.5.5 0 0 0-.335.14.62.62 0 0 0-.196.317l-.457 2.176a.35.35 0 0 0 .069.318q.111.14.281.14h2.18q.212 0 .17.223l-1.893 9.372q-.042.235-.255.235H2.967a.5.5 0 0 0-.324.133.6.6 0 0 0-.197.313l-.435 2.175a.5.5 0 0 0-.011.101q0 .123.074.223.107.134.266.134z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=EditorTextItalic.js.map